import { authConfig as config } from '../../../../util/auth-config'
import { useSignInWithApple } from '../../../../hook/use-sign-in-with-apple'
import { OverlaySpinner } from '../../util/spinner/overlay-spinner'
import AppleSignin from 'react-apple-signin-auth'
import React, { useContext } from 'react'
import { AuthSessionContext } from '../../../../context/auth-session-context'

interface AppleSignInButtonProps {
  disabled?: boolean
}

export const AppleSignInButton = ({ disabled }: AppleSignInButtonProps): React.ReactElement => {
  const { redirectUrl } = useContext(AuthSessionContext)
  const { handleSuccess, handleError, isLoading } = useSignInWithApple(redirectUrl)

  return (
    <>
      <div
        className="w-full"
        style={{ pointerEvents: disabled || isLoading ? 'none' : 'auto', opacity: disabled || isLoading ? 0.6 : 1 }}
      >
        <AppleSignin
          uiType="dark"
          authOptions={{
            clientId: config.apple.clientId,
            scope: 'email name',
            redirectURI: `${window.location.origin}/auth/callback`,
            state: 'state',
            nonce: 'nonce',
            usePopup: true,
          }}
          onSuccess={handleSuccess}
          onError={handleError}
          render={(props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
            <button
              {...props}
              // `lg:h-[clamp(...)]` is the GH-908 vertical scale — 72px at the 900px-tall design
              // target, down to 56px on a laptop. See `get-in-split-layout.tsx`.
              className="w-full h-[72px] lg:h-[clamp(56px,8dvh,72px)] flex items-center justify-center gap-3 bg-white border border-black rounded-[4px] font-medium text-[18px] text-black hover:bg-gray-50 transition-colors"
            >
              <svg width="32" height="32" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.175 15.225C13.275 16.05 12.3 15.9 11.3625 15.45C10.3725 14.9925 9.4575 14.9775 8.4075 15.45C7.11 16.05 6.42 15.87 5.625 15.225C1.2 10.65 1.8375 3.9 6.8625 3.6375C8.1 3.705 8.9625 4.3125 9.675 4.365C10.7475 4.1475 11.775 3.525 12.9225 3.6075C14.295 3.72 15.3375 4.245 16.035 5.1825C13.1625 6.8925 13.8375 10.695 16.4625 11.7675C15.93 13.155 15.2475 14.5275 14.1675 15.2325L14.175 15.225ZM9.5775 3.5775C9.45 1.6725 10.9875 0.0975 12.7725 -0.0525C13.02 2.145 10.7475 3.825 9.5775 3.5775Z"
                  fill="black"
                />
              </svg>
              Sign in with Apple
            </button>
          )}
        />
      </div>
      {isLoading && <OverlaySpinner />}
    </>
  )
}
